const faqItems = [
  {
    q: '90影视网站是否需要注册才能观看？',
    a: '不需要。90影视官网所有影视内容均支持免注册免费在线观看，打开网站即可直接浏览和播放，无需账号登录、无任何付费墙，真正做到即点即看。',
  },
  {
    q: '90影视的最新访问地址从哪里获取？',
    a: '由于影视网站的域名可能发生变动，建议您收藏本页面或下载90影视APP，我们会实时更新最新访问入口。同时可以通过官方微信公众号"90ys_official"获取最新地址推送。',
  },
  {
    q: '在90影视观看视频会卡顿吗？',
    a: '90影视采用多线路CDN加速与智能缓冲技术，99.9%的影片均可流畅播放。如遇卡顿，建议切换备用播放线路或检查您的网络环境，通常切换后即可恢复正常。',
  },
  {
    q: '90影视APP在哪里下载？支持哪些系统？',
    a: '90影视APP目前支持Android与iOS双平台。您可以在本页面的APP下载区域扫码或点击链接下载安装。APP相比网页端播放更稳定，支持离线缓存与投屏功能。',
  },
  {
    q: '90影视的资源更新频率如何？',
    a: '我们每日同步更新50部以上影视内容，覆盖最新院线电影、卫视热播剧、综艺动漫及海外剧集。热门大片通常在院线上映后一周内上线高清版本，追剧党首选。',
  },
  {
    q: '如何向90影视推荐影片或提交资源？',
    a: '欢迎通过联系邮箱 contact@90ys.tv 或官方微信公众号向我们推荐您想看的影片。如果发现资源失效或画质问题，也可以通过同样方式反馈，我们会尽快处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于90影视官网使用、APP下载、资源获取等常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden" open={i < 3}>
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-8">{item.q}</h3>
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}